import Button from './Button';

export default function DraftModeChoicePopover({
  show,
  onCancel,
  onChooseFresh,
  onChooseRecent,
  title = 'Choose Draft Mode',
  description = 'A recent draft exists for this company and template. Use it for fastest response, or create a fresh AI draft.',
}) {
  if (!show) return null;

  return (
    <div className="absolute right-4 top-3 z-30 w-[min(430px,92vw)] rounded-2xl border bg-white shadow-[0_16px_38px_rgba(8,17,31,0.2)]">
      <div className="px-4 py-3 border-b" style={{ borderColor: '#ece5d8' }}>
        <div className="text-[12px] font-bold text-[#102437]">{title}</div>
        <div className="text-[11px] text-[#5d6472] mt-1">{description}</div>
      </div>
      <div className="p-3 flex items-center gap-2 justify-end bg-[#fcfaf5] rounded-b-2xl">
        <Button variant="outline" size="sm" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="outline" size="sm" onClick={onChooseFresh}>
          Create Fresh Draft
        </Button>
        <Button variant="primary" size="sm" onClick={onChooseRecent}>
          Use Recent Draft
        </Button>
      </div>
    </div>
  );
}
